import { z } from "zod";

export const SESSION_STORAGE_KEY = "plp_jldata_listing";

const listingSearchSchema = z.object({
  term: z.string(),
  typed: z.string(),
  method: z.string(),
});

const listingContextSchema = z.object({
  search: listingSearchSchema.optional(),
  filter: z.string().optional(),
  pageNum: z.string().optional(),
  displayNum: z.number().optional(),
  totalNumberOfResults: z.number().optional(),
  sort: z.string().optional(),
  resultNum: z.number().optional(),
  categoryId: z.string().optional(),
});

const storedListingContextSchema = z.object({
  productId: z.string(),
  listing: listingContextSchema,
});

export type ListingContext = z.infer<typeof listingContextSchema>;

export const getListingContext = (
  currentProductId: string,
): ListingContext | undefined => {
  try {
    const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (!raw) return undefined;

    const parsed = JSON.parse(raw);
    const result = storedListingContextSchema.safeParse(parsed);

    if (!result.success) return undefined;
    if (result.data.productId !== currentProductId) return undefined;

    return result.data.listing;
  } catch {
    return undefined;
  }
};
